export const SAVINGS_CALCULATOR_SET_VALUE = 'savings/calculator/setValue/';

export const WHAT_TO_CALCULATE_SET_VALUE = SAVINGS_CALCULATOR_SET_VALUE + 'whatToCalculate';

export const REFERENCE_DATA_SET_VALUE = SAVINGS_CALCULATOR_SET_VALUE + 'referenceData';

export const setWhatToCalculateValue = value => ({ type: WHAT_TO_CALCULATE_SET_VALUE, value });
export const setReferenceData = () => ({ type: REFERENCE_DATA_SET_VALUE });
